"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as n, forwardRef as i } from "react";
import { useSvgIcon as l } from "../useSvgIcon.js";
const c = n(
  i((e, r) => {
    const { monochrome: m, ...C } = e, t = l({
      ...C,
      ref: r
    });
    return /* @__PURE__ */ o(
      "svg",
      {
        width: 24,
        height: 24,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t(),
        children: /* @__PURE__ */ o(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4.95491 9.06107C4 10.3754 4 12.2503 4 16C4 19.7497 4 21.6246 4.95491 22.9389C5.26331 23.3634 5.6366 23.7367 6.06107 24.0451C7.3754 25 9.25027 25 13 25H19C22.7497 25 24.6246 25 25.9389 24.0451C26.3634 23.7367 26.7367 23.3634 27.0451 22.9389C28 21.6246 28 19.7497 28 16C28 12.2503 28 10.3754 27.0451 9.06107C26.7367 8.6366 26.3634 8.26331 25.9389 7.95491C24.6246 7 22.7497 7 19 7H13C9.25027 7 7.3754 7 6.06107 7.95491C5.6366 8.26331 5.26331 8.6366 4.95491 9.06107ZM12.8543 12.06L20.719 15.6214C20.8933 15.7 21 15.8448 21 16.0006C21 16.1564 20.8927 16.3008 20.719 16.3793L12.8543 19.9399C12.7658 19.9798 12.667 20 12.5676 20C12.47 20 12.3724 19.9807 12.285 19.9421C12.109 19.864 12 19.7182 12 19.5611V12.4388C12 12.2812 12.109 12.1359 12.2855 12.0578C12.4621 11.9797 12.6795 11.981 12.8543 12.06Z",
            fill: "var(--icon-color)"
          }
        )
      }
    );
  })
);
c.displayName = "IconYoutube";
export {
  c as IconYoutube
};
